export default "__VITE_ASSET__aba6e6c9__"